/** Module icon tile: a Lucide glyph on its tone's ramp (tokens only). */
import {
  Activity,
  BadgeCheck,
  BarChart3,
  Box,
  CalendarPlus,
  Clock,
  Globe,
  Package,
  Scale,
  ShieldCheck,
  Tablet,
  MessageSquare,
  Monitor,
  PhoneCall,
  Radio,
  ScanLine,
  Sparkles,
  Star,
  Stethoscope,
  TrendingUp,
  type LucideIcon,
} from 'lucide-react';
import type { CatalogModule } from '@velora/contracts/marketplace';

const ICONS: Record<string, LucideIcon> = {
  'message-square': MessageSquare,
  star: Star,
  'phone-call': PhoneCall,
  activity: Activity,
  stethoscope: Stethoscope,
  'bar-chart-3': BarChart3,
  'scan-line': ScanLine,
  box: Box,
  monitor: Monitor,
  radio: Radio,
  'calendar-plus': CalendarPlus,
  'badge-check': BadgeCheck,
  sparkles: Sparkles,
  clock: Clock,
  'shield-check': ShieldCheck,
  tablet: Tablet,
  scale: Scale,
  globe: Globe,
  package: Package,
  'trending-up': TrendingUp,
};

export function ModuleIcon({
  module,
  size = 'md',
}: {
  module: Pick<CatalogModule, 'icon' | 'tone'>;
  size?: 'sm' | 'md' | 'lg';
}) {
  const Icon = ICONS[module.icon] ?? Sparkles;
  const px = size === 'lg' ? 28 : size === 'sm' ? 15 : 18;
  return (
    <span className="mk-icon" data-tone={module.tone} data-size={size} aria-hidden>
      <Icon size={px} strokeWidth={1.75} />
    </span>
  );
}
